export const formatCurrency = ({
    value,
    code,
    symbol = '$',
    locale,
    decimals = 2,
}: {
    value: number;
    symbol?: string;
    code?: string;
    locale?: string;
    decimals?: number;
}): string => {
    const userLocale = locale ? locale : Intl.NumberFormat().resolvedOptions().locale;
    const valueFormatter = new Intl.NumberFormat(userLocale, {
        style: 'decimal',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        ...(code ? { currency: code } : {}),
    });

    const formatedValue = valueFormatter.format(value);

    return `${symbol}${formatedValue}`;
};

export const findCurrencyByCodeIn = <T extends { code: string }>(
    currencies: T[],
    code: string | undefined | null
): T | undefined => {
    if (!code || currencies.length === 0) return undefined;
    return currencies.find(c => c.code.toUpperCase() === code.toUpperCase());
};
